export default __webpack_public_path__ + "static/media/001-chess.a9feee85.svg";